// extracted by mini-css-extract-plugin
export default {"header":"style_header__phPj5","burgerMenu":"style_burgerMenu__KOJ2g","optionsMenu":"style_optionsMenu__gWhXK","hide":"style_hide__2d+Bi"};